import { useAction } from "./useAction";
import { Apartamento } from "../interfaces/Apartamento";
import { cadastrarApartamentoService } from "../services/cadastrarApartamentoService";

export const useCadastrarApartamento = () => {
  const {
    execute: cadastrarApartamento,
    isLoading,
    data,
    error,
    success,
  } = useAction<Apartamento>(cadastrarApartamentoService);

  const handleSubmit = async (apartamento: Apartamento) => {
    try {
      const response = await cadastrarApartamento(apartamento);
      console.log("Apartamento cadastrada com sucesso", response);
      return response;
    } catch (error) {
      console.error("Erro ao cadastrar apartamento", error);
      throw error; // propaga erro para quem chamou
    }
  };

  return {
    handleSubmit,
    isLoading,
    data,
    error,
    success,
  };
};
